import React, { useState } from 'react';
import { Form, Button,Badge, Container, Alert } from 'react-bootstrap';
import Accordion from 'react-bootstrap/Accordion'

const Choise = () => {
  const [enteredId, setId] = useState('');
  const [enteredName, setName] = useState('');
  const [enteredRole, setRole] = useState('');

  /*
    const IdChangeHandler = (event) => {
      setId(event.target.value);
    };
  
    const nameChangeHandler = (event) => {
      setName(event.target.value);
    };
  
    const roleChangeHandler = (event) => {
      setRole(event.target.value);
    };
  
  */
  const submitHandler = (event) => {

    event.preventDefault();
    window.open(
      "https://forms.zohopublic.in/nest/form/Selection/formperma/eGYwm8fYi1KpPNR519olJq4VoFYWim15j6i4ny2LR3M", "_self");

    /*/reset the values of input fields
        setId('');
        setName('');
        setRole('');

    return alert('Entered Values are: '+enteredId+','+ enteredName +','+enteredRole)
*/

  };

  return (
    <>
      <h4>Narmada Education & Scientific Research Society</h4>
      <h6>PDIS & PDIETM admission</h6>
      <h6> Say hi to +918160579963 on Whatsapp to join Helpline or click on following link</h6>
      <h6><a href="https://wa.me/+918160579963?text=hi">Helpline!</a></h6>
      <b>Please read carefully following instructions before apply for the admission application and then click on Agree button.</b>
      <Accordion >
        <Accordion.Item eventKey="0">
          <Accordion.Header>Instructions</Accordion.Header>
          <Accordion.Body>
            <p>A separate admission form is required for each course.</p>
            <p>Admission procedure for new batch of PDIS-50 seats & PDIETM-25 seats is to be done ONLINE.</p>
            <p><b>Birth place:</b> Applicant should write the birth place and if it is outside Gujarat then applicant should submit Domicile certificate- a proof of stay in Gujarat for more than last ten years to be issued by local <b>Mamlatdar</b> office.</p>
            <p><b>Caste Category:</b>Applicant should select appropriate caste, if selected caste is SC and ST, then only caste certificate is to be submitted. <p>But if selected caste is SEBC, then in addition to the caste certificate Creamy layer certificate having validity of current financial year should submit.</p> <p>In case of EWS, EWS certificate is to be submitted.</p>

            </p>
            <p><b>Qualification:</b>Applicant shall select the maximum qualification acquire. In case of Diploma and BSc. Working experience of two years excluding of training and apprentice period after passing the Diploma or BSc.


            </p>
            <p>
              <b>NOC:</b>Applicant should submit the NOC from the present employer in original copy. This NOC should clearly mention the name of candidate, course name PDIS/ PDIETM- <b>separate</b> for both and institution name- Narmada Education & Scientific Research Society, GNFC-Bharuch.

            </p>
            <p>
              <b>Bring the original, self attested Xerox of all the documents  uploaded by the applicant and certificate of experience  at the time of interview.</b>
            </p>
          </Accordion.Body>
        </Accordion.Item>
        <Accordion.Item eventKey="1">
          <Accordion.Header>સૂચનાઓ</Accordion.Header>
          <Accordion.Body>
            <p>PDIS-50 બેઠકો અને PDIETM-25 બેઠકોની નવી બેચ માટે પ્રવેશ પ્રક્રિયા ઓનલાઈન કરવાની છે</p>
            <p>દરેક કોર્સ માટે અલગ પ્રવેશ ફોર્મ ભરવું </p>
            <p><b>Birth place:</b> અરજદાર નું જન્મ સ્થળ  ગુજરાતની બહાર હોય તો અરજદારે સ્થાનિક મામલતદાર કચેરી પાસેથી મેળવેલું - ડોમિસાઈલ પ્રમાણપત્ર સબમિટ કરવું

            </p>
            <p><b>Caste Category:</b>. જો પસંદ કરેલ જાતિ SC અને ST હોય, તો માત્ર જાતિ પ્રમાણપત્ર સબમિટ કરવાનું રહેશે.</p>
            <p> પરંતુ જો પસંદ કરેલ જાતિ SEBC હોય, તો જાતિ પ્રમાણપત્ર ઉપરાંત ચાલુ નાણાકીય વર્ષની માન્યતા ધરાવતું ક્રીમી લેયર પ્રમાણપત્ર સબમિટ કરવું       </p>
            <p>EWS ના કિસ્સામાં, EWS પ્રમાણપત્ર સબમિટ કરવાનું રહેશે.</p>
            <p><b>Qualification:</b>ડિપ્લોમા અથવા બીએસસી  થયેલાં  ઉમેદવારે પાસે  બે વર્ષનો કાર્ય અનુભવ હોવો જોઈએ.<p> તાલીમ અને એપ્રેન્ટિસ નો સમય સમાવેશ અનુભવ માટે માન્ય ગણાશે નહિ .</p>
            </p>
            <p>
              <b>NOC:</b>
              અરજદારે અત્યારે જ્યાં નોકરી  કરતો હોય તે એમ્પ્લોયર પાસેથી  લીધેલું  NOC સબમિટ કરવું. આ NOCમાં ઉમેદવારનું નામ, કોર્સનું નામ PDIS/PDIETM- નર્મદા એજ્યુકેશન એન્ડ સાયન્ટિફિક રિસર્ચ સોસાયટી, GNFC-ભરૂચનો સ્પષ્ટ ઉલ્લેખ હોવો જોઈએ.

            </p>
            <p>અરજદારે ઇન્ટરવ્યુ સમયે અપલોડ કરેલા બધાજ ડોક્યુમેન્ટની ઓરીજીનલ, સેલ્ફ અટેસ્ટેડ  ઝેરોક્સ તથા અનુભવ નું સર્ટિફિકેટ  લઈને  આવવું

            </p>
          </Accordion.Body>
        </Accordion.Item>
        <Accordion.Item eventKey="2">
          <Accordion.Header>NOC Format</Accordion.Header>
          <Accordion.Body><h6>No objection certificate</h6>

<p>Reference number. ______.  
  <br></br> Outward number. ______.</p> 
<br/>

This is  to inform you that we have No Objection if Shri/Ms._________________________ employee code number ____ is given admission to two year part time evening course of _____________________________ , run by Narmada Education & Scientific Research Society (NEST), at training center GNFC ltd, Bharuch. We shall permit him /her to attend the classes regularly and allow him /her to complete the course and appear at the examination.
<br/><br/><br/>

Signature of the company authority  ___________
<br/><br/>
Name and designation  _________________
<br/>
Place <br/>
Date<br/>
<br/>
<br/>
Company address with phone number and seal.



          </Accordion.Body>

          </Accordion.Item >

      </Accordion>


      <Form onSubmit={submitHandler}>
         {/* <Form.Group  controlId="form.id">
            <Form.Label>Id</Form.Label>
            <Form.Control type="number" value={enteredId} onChange={IdChangeHandler}placeholder="Enter Id" required/>
        </Form.Group>
        <Form.Group controlId="form.Name">
            <Form.Label>User Name</Form.Label>
            <Form.Control type="text" value={enteredName} onChange={nameChangeHandler} placeholder="Enter User Name" required/>
        </Form.Group>
        <Form.Group  controlId="form.Role">
            <Form.Label>Role</Form.Label>
            <Form.Control type="text" value={enteredRole} onChange={roleChangeHandler} placeholder="Enter Role" required/>
    </Form.Group>*/}
        <Button type='submit'>Agree</Button>
      </Form>
      <footer className="footer">
        Designed by
      <Badge bg="dark">marubharuch</Badge>
            <br></br><i><small>
            18 Narmada Darshan complex,Opp. GEB, Maktampur, Bharuch</small></i>
            <p>Call Us<Badge bg="dark"><a href="tel:9974021397">9974021397</a></Badge></p>
          </footer>
    </>

  );
}
export default Choise;
